module.exports = __webpack_public_path__ + "static/media/phone.60da3b75.svg";